export default "__VITE_ASSET__DuMMH_F0__"